{
  "_from": "aws-appsync-auth-link",
  "_id": "aws-appsync-auth-link@3.0.7",
  "_inBundle": false,
  "_integrity": "sha512-Jsa53opryGFIOHGok74ICfboxhDN64o11Z+aXoCrAnE0TwzJMMK1F20ha6sYzUuozY9pGYeE+EQ3OVn6waYMog==",
  "_location": "/aws-appsync-auth-link",
  "_phantomChildren": {
    "@aws-sdk/types": "3.78.0",
    "@aws-sdk/util-utf8-browser": "3.55.0"
  },
  "_requested": {
    "type": "tag",
    "registry": true,
    "raw": "aws-appsync-auth-link",
    "name": "aws-appsync-auth-link",
    "escapedName": "aws-appsync-auth-link",
    "rawSpec": "",
    "saveSpec": null,
    "fetchSpec": "latest"
  },
  "_requiredBy": [
    "#USER",
    "/"
  ],
  "_resolved": "https://registry.npmjs.org/aws-appsync-auth-link/-/aws-appsync-auth-link-3.0.7.tgz",
  "_shasum": "2b676b9198101055b91a15b367f9ef2805f2d766",
  "_spec": "aws-appsync-auth-link",
  "_where": "/Users/jakubknejzlik/projects/gitlab.com/novacloud/projects/user-lock/user-lock-frontend",
  "author": {
    "name": "Amazon Web Services",
    "url": "https://aws.amazon.com/"
  },
  "bugs": {
    "url": "https://github.com/awslabs/aws-mobile-appsync-sdk-js/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "@aws-crypto/sha256-js": "^1.2.0",
    "@aws-sdk/types": "^3.25.0",
    "@aws-sdk/util-hex-encoding": "^3.29.0",
    "debug": "2.6.9"
  },
  "deprecated": false,
  "description": "AWS Mobile AppSync Auth Link for JavaScript",
  "devDependencies": {
    "@apollo/client": "^3.2.0"
  },
  "homepage": "https://github.com/awslabs/aws-mobile-appsync-sdk-js.git",
  "license": "Apache-2.0",
  "main": "lib/index.js",
  "name": "aws-appsync-auth-link",
  "peerDependencies": {
    "@apollo/client": "3.x"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/awslabs/aws-mobile-appsync-sdk-js.git"
  },
  "scripts": {
    "prepare": "tsc",
    "test": "jest --coverage --coverageReporters=text --passWithNoTests",
    "test-watch": "jest --watch"
  },
  "version": "3.0.7"
}
